import { Component, inject, OnInit } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { NgClass } from '@angular/common';

enum NotificationMessageType {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
}

@Component({
    selector: 'bh-notifications',
    templateUrl: 'notification.component.html',
    imports: [NgClass]
})
export class NotificationComponent implements OnInit {
    notificationService = inject(NotificationService);
    readonly NotificationMessageType = NotificationMessageType;

    btnText: string;

    ngOnInit() {
        this.notificationService.getBtnText().subscribe(btnText => {
            this.btnText = btnText;
        });
    }
}
